module.exports = __webpack_public_path__ + "img/kinda_lock.0a63c861.jpg";